/*
  BePro = 10,
  AssiomaUno = 11,
  AssiomaDuo = 12,
  AssiomaDuoShi = 13,
  AssiomaProMx1 = 21,
  AssiomaProMx2 = 22,
  AssiomaProRs1 = 31,
  AssiomaProRs2 = 32,
  AssiomaProRl1 = 41,
  AssiomaProRl2 = 42
  Unknown = -1,

*/


document.addEventListener('DOMContentLoaded', function() {
  // prende tutte le select dei prodotti (tutte i form)
  const selects = document.querySelectorAll('select[name="form_fields[purchased_product]"]');
  if (!selects || selects.length === 0) return;

  selects.forEach(selectProdotto => {
    // trova il form / container più vicino (adatta il selettore se necessario)
    const container = selectProdotto.closest('form') || selectProdotto.closest('.elementor-form') || document;

    // campi scoped al singolo form
    const campi = {
      pedaleSX: container.querySelector('.elementor-field-group-pedaleSX'),
      pedaleDX: container.querySelector('.elementor-field-group-pedaleDX'),
      antId:    container.querySelector('.elementor-field-group-antId')
    };

    function setRequiredIndicator(label, obbligatorio) {
      if (!label) return;
      // Elementor spesso usa uno span per l'asterisco; controlliamo ed evitiamo di sovrascrivere HTML
      let asterisco = label.querySelector('.required-asterisk');
      if (obbligatorio) {
        if (!asterisco) {
          asterisco = document.createElement('span');
          asterisco.className = 'required-asterisk';
          asterisco.textContent = ' *';
          label.appendChild(asterisco);
        }
      } else {
        if (asterisco) asterisco.remove();
      }
    }

    // mostra/nascondi e required (scoped)
    function aggiornaCampo(campo, visibile, obbligatorio) {
      if (!campo) return;
      const input = campo.querySelector('input, select, textarea');
      const label = campo.querySelector('label');

      campo.style.display = visibile ? 'block' : 'none';

      if (input) {
        if (obbligatorio) input.setAttribute('required', 'required');
        else input.removeAttribute('required');
      }
      setRequiredIndicator(label, obbligatorio);
    }

    function aggiornaVisibilita() {
      const valore = (selectProdotto.value || '').trim();

      /* ---- PEDALE SX ---- */
      if (
        valore === '12' ||
        valore === '11' ||
        valore === '13' ||
        valore === '21' ||
        valore === '22' ||
        valore === '31' ||
        valore === '32' ||
        valore === '41' ||
        valore === '42'
      ) {
        const obbligatorio = !(valore === '31' || valore === '32');
        aggiornaCampo(campi.pedaleSX, true, obbligatorio);
      } else {
        aggiornaCampo(campi.pedaleSX, false, false);
      }

      /* ---- PEDALE DX ---- */
      if (
        valore === '12' ||
        valore === '13' ||
        valore === '22' ||
        valore === '32' ||
        valore === '42'
      ) {
        aggiornaCampo(campi.pedaleDX, true, true);
      } else {
        aggiornaCampo(campi.pedaleDX, false, false);
      }

      /* ---- ANT ID ---- */
      if (valore === '10') {
        aggiornaCampo(campi.antId, true, true);
      } else {
        aggiornaCampo(campi.antId, false, false);
      }
    }

    // bind e primo aggiornamento per questo form
    selectProdotto.addEventListener('change', aggiornaVisibilita);
    aggiornaVisibilita();
  });
});



// WEBPACK FOOTER //
// ./js/widget/form-elementor.js